// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.po_items_ho {
    column-width: 15em;
    column-gap: 4rem;
}

.po_item {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin: 0.5rem auto;
    position: relative;
    background: var(--secondary-color);
    padding: 6px;
    border: 1px solid var(--secondary-color);
    transition: 0.3s ease;
    font-size: 0;
    min-height: 300px;
}

.po_item img {
    max-width: 100%;
}

.po_item .content {
    position: absolute;
    height: 0;
    width: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--overlay-color);
    z-index: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    transition: 0.3s ease-in-out;
    opacity: 0;
    border: 1px solid black;
}

.po_item .content {
    opacity: 0;
    transition-delay: 1s;
    transition: 0.3s ease;
    font-size: 20px;
}

.po_item:hover {
    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.25);
}

.po_item:hover .content {
    height: calc(100% - 30px);
    width: calc(100% - 30px);
    opacity: 1;
}

.po_item:hover .content {
    opacity: 1;
    color: var(--secondary-color);
}

.po_item .content a {
    background: var(--bg-color);
    border: solid 1px var(--text-color);
    padding: 4px 8px;
    text-align: center;
    font-size: 1rem;
}

.po_item .content a:hover {
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/portfolio/style.css"],"names":[],"mappings":"AAAA;IAGI,kBAAkB;IAGlB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,wCAAwC;IACxC,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gCAAgC;IAChC,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".po_items_ho {\n    -webkit-column-width: 15em;\n    -moz-column-width: 15em;\n    column-width: 15em;\n    -webkit-column-gap: 4rem;\n    -moz-column-gap: 4rem;\n    column-gap: 4rem;\n}\n\n.po_item {\n    display: inline-block;\n    width: 100%;\n    text-align: center;\n    margin: 0.5rem auto;\n    position: relative;\n    background: var(--secondary-color);\n    padding: 6px;\n    border: 1px solid var(--secondary-color);\n    transition: 0.3s ease;\n    font-size: 0;\n    min-height: 300px;\n}\n\n.po_item img {\n    max-width: 100%;\n}\n\n.po_item .content {\n    position: absolute;\n    height: 0;\n    width: 0;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: var(--overlay-color);\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    transition: 0.3s ease-in-out;\n    opacity: 0;\n    border: 1px solid black;\n}\n\n.po_item .content {\n    opacity: 0;\n    transition-delay: 1s;\n    transition: 0.3s ease;\n    font-size: 20px;\n}\n\n.po_item:hover {\n    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.25);\n}\n\n.po_item:hover .content {\n    height: calc(100% - 30px);\n    width: calc(100% - 30px);\n    opacity: 1;\n}\n\n.po_item:hover .content {\n    opacity: 1;\n    color: var(--secondary-color);\n}\n\n.po_item .content a {\n    background: var(--bg-color);\n    border: solid 1px var(--text-color);\n    padding: 4px 8px;\n    text-align: center;\n    font-size: 1rem;\n}\n\n.po_item .content a:hover {\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
